import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cmd00610-input-form q-gutter-y-md" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col column" }
const _hoisted_4 = {
  id: "sketch-iframe",
  ref: "sketch-iframe",
  "data-toolbars": "reporting",
  title: "marvin js editor",
  src: "../../sketch/editorws.html",
  style: {"overflow":"hidden","width":"100%","height":"100% min-width: 500px","min-height":"350px","border":"1px solid darkgray"}
}
const _hoisted_5 = { class: "cmd00610-button-area row" }
const _hoisted_6 = { class: "col q-gutter-x-xs flex justify-end" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import { clearMarvin, getMarvin } from '../../common/marvin-js';
import http from '../../common/axios-common';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';

// ダイアログ表示判断

export default /*@__PURE__*/_defineComponent({
  __name: 'CMD00610',
  setup(__props) {

const openDialog = ref(false);

// 登録確認ダイアログ
const confirmationDialog = ref(false);

// 登録完了ダイアログ
const registDialog = ref(false);

// ダイアログタイトル
const dialogTittle = ref<string>('');

// ダイアログテキスト
const dialogText = ref<Array<string>>(['']);

const router = useRouter();

// ダイアログ閉じる
const closeDialog = () => {
  openDialog.value = false;
};

// 戻るボタン押下時
const pageBack = () => {
  router.push({ name: 'attoId' });
};

// 構造式エディター未入力ダイアログ
const inputErrDialog = () => {
  openDialog.value = true;
  dialogTittle.value = '入力エラー';
  dialogText.value = ['構造式を入力してください。'];
};

// MarvinJs読み込み失敗ダイアログ
const readErrDialog = () => {
  openDialog.value = true;
  dialogTittle.value = 'MarvinJs読み込みエラー';
  dialogText.value = ['構造式の取得に失敗しました。', '画面を開き直して再度お試しください。'];
};

// 新規登録
const registAttoID = () => {
  confirmationDialog.value = false;
  getMarvin().then((structure: string) => {
    // MarvinJs読み込み失敗
    if (structure === 'error') {
      // MarvinJs読み込み失敗ダイアログ
      readErrDialog();
    }
    // 構造式エディターに入力されていない場合
    if (structure === undefined) {
      // 構造式エディター未入力ダイアログ
      inputErrDialog();
    }
    // 構造式エディターに入力されている場合
    else {
      // Loading Start
      Loading.show();
      const formData = new FormData();
      // バックエンドに渡すデータに構造式を設定
      formData.append('structure', structure);

      // 新規登録
      http
        .post('/cmd006101/registAttoId', formData)
        .then((response) => {
          if (response.data.common.status === ResultStatusCode.ERROR) {
            if (
              response.data.common.detail_status === DetailResultStatusCode.DUPLICATE_SUPPLIER_ERROR
            ) {
              // 登録重複ダイアログ
              openDialog.value = true;
              dialogTittle.value = '登録重複エラー';
              dialogText.value = [response.data.common.message];
            } else if (response.data.common.detail_status === DetailResultStatusCode.INSERT_ERROR) {
              // 登録失敗ダイアログ
              openDialog.value = true;
              dialogTittle.value = '登録エラー';
              dialogText.value = [response.data.common.message];
              // その他のエラー
            } else {
              router.push({ name: 'error' });
            }
          } else {
            // 登録完了ダイアログ
            registDialog.value = true;
            dialogTittle.value = '登録完了';
            const text = response.data.common.message.split(' ');
            dialogText.value = text;
          }
        })
        .catch((err) => {
          if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
            // セッションタイムアウト
            router.push({ name: 'login', query: { timeout: 'timeout' } });
          } else {
            // その他エラー
            router.push({ name: 'error' });
          }
        })
        .finally(() => {
          // Loading End
          Loading.hide();
        });
    }
  });
};
const checkContents = () => {
  getMarvin().then((structure: string) => {
    // MarvinJs読み込み失敗
    if (structure === 'error') {
      // MarvinJs読み込み失敗ダイアログ
      readErrDialog();
    }
    // 構造式エディターに入力されていない場合
    if (structure === undefined) {
      // 構造式エディター未入力ダイアログ
      inputErrDialog();
    }
    // 構造式エディターに入力されている場合
    else {
      confirmationDialog.value = true;
    }
  });
};
// クリアボタン押下時新規登録入力内容クリア
const clear = () => {
  clearMarvin().then((err: string) => {
    // MarvinJs読み込み失敗
    if (err === 'error') {
      dialogTittle.value = 'MarvinJs読み込みエラー';
      dialogText.value = ['構造式のクリアに失敗しました。', '画面を開き直して再度お試しください。'];
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[7] || (_cache[7] = [
        _createElementVNode("span", null, "ATTOID新規登録", -1)
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "requier" }, "構造式", -1)),
          _createElementVNode("iframe", _hoisted_4, null, 512)
        ])
      ])
    ]),
    _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
      "button-area": _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_q_btn, {
            color: "grey-7",
            outline: "",
            label: "戻る",
            style: {"min-width":"120px","background":"var(--q-white) !important"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (pageBack()))
          }),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_q_btn, {
              color: "primary",
              style: {"width":"150px"},
              label: "登録",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (checkContents()))
            }),
            _createVNode(_component_q_btn, {
              color: "q-gray-3",
              outline: "",
              style: {"width":"150px","background":"var(--q-white) !important"},
              icon: "mdi-eraser",
              label: "クリア",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (clear()))
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(AlertDialog, {
      display: openDialog.value,
      level: "error",
      confirmation: "",
      title: dialogTittle.value,
      text: dialogText.value,
      onComplete: closeDialog,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (openDialog.value = false))
    }, null, 8, ["display", "title", "text"]),
    _createVNode(AlertDialog, {
      display: registDialog.value,
      level: "information",
      confirmation: "",
      title: dialogTittle.value,
      text: dialogText.value,
      onComplete: pageBack,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (registDialog.value = false))
    }, null, 8, ["display", "title", "text"]),
    _createVNode(AlertDialog, {
      display: confirmationDialog.value,
      level: "information",
      title: '登録確認',
      text: ['入力された内容で登録します。', 'よろしいですか？'],
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (registAttoID())),
      onClose: _cache[6] || (_cache[6] = ($event: any) => (confirmationDialog.value = false))
    }, null, 8, ["display"])
  ]))
}
}

})